/**
 * @fileoverview O que cada quadro do Multi unidades mostra, para o modal do
 * clique: título, explicação curta e o que é o valor de cada ticket.
 *
 * Os textos descrevem a conta que o servidor faz (MONTHLY_SERIES em
 * MultiUnitChartsService e os contadores do topo): mudou a conta, muda o texto.
 */

export const CARD_INFO = {
  // ── Cartões do topo ──
  activeNow: {
    kind: "live",
    title: "Ativos agora",
    explanation:
      "Conversas abertas ou pendentes que tiveram alguma atividade nas últimas 24 horas.",
    valueLabel: "Última atividade há",
    isTime: false,
  },
  noResponse: {
    kind: "live",
    title: "Sem resposta",
    explanation:
      "Conversas ativas em que o cliente falou por último há 10 minutos ou mais. Na conta que usa expediente, contam só os minutos de expediente. Uma resposta curta do cliente (\"ok\", 👍) não conta como fala dele.",
    valueLabel: "Esperando há",
    isTime: false,
  },
  artRolling: {
    kind: "art",
    title: "ART rolling 24h",
    explanation:
      "Tempo médio, em horário de expediente, entre cada mensagem do cliente e a primeira resposta que chegou a ele, nas últimas 24 horas. Cada resposta conta para quem a assinou.",
  },
  topOffenders: {
    kind: "art",
    worstFirst: true,
    title: "Ofensores · ART",
    explanation:
      "Quem mais demorou para responder nas últimas 24 horas: o tempo médio, em horário de expediente, entre a mensagem do cliente e a primeira resposta de cada pessoa.",
  },

  // ── Gráficos de 12 meses ──
  openNoReply: {
    kind: "monthly",
    title: "Casos sem resposta",
    explanation:
      "Conversas ainda abertas em que o cliente falou por último e ninguém respondeu. Cada uma entra no mês da última atividade. Uma resposta curta do cliente não conta como fala dele.",
    valueLabel: "Cliente esperando há",
    isTime: false,
  },
  longestNoReplyAttendantSec: {
    kind: "monthly",
    title: "Maior tempo sem resposta",
    explanation:
      "A maior espera de agora entre as conversas abertas em que o cliente falou por último, pelo mês da última atividade. O número é o do primeiro ticket da lista.",
    valueLabel: "Cliente esperando há",
    isTime: true,
  },
  avgFirstReplyAttendantSec: {
    kind: "monthly",
    title: "Tempo até a última resposta",
    explanation:
      "Média do tempo entre a abertura do ticket e a última mensagem do atendente, nos tickets abertos no mês. Não é o tempo da primeira resposta.",
    valueLabel: "Até a última resposta",
    isTime: true,
  },
  longestFirstReplySec: {
    kind: "monthly",
    title: "Maior tempo até a última resposta",
    explanation:
      "O maior tempo entre a abertura do ticket e a última mensagem do atendente, nos tickets abertos no mês. Não é o tempo da primeira resposta.",
    valueLabel: "Até a última resposta",
    isTime: true,
  },
  avgFirstReplyClientSec: {
    kind: "monthly",
    title: "ART médio · cliente",
    explanation:
      "Média do tempo entre a última resposta do atendente e a última mensagem do cliente, quando o cliente escreveu depois. Pelo mês da última atividade.",
    valueLabel: "Cliente levou",
    isTime: true,
  },
  totalOpen: {
    kind: "monthly",
    title: "Casos abertos no mês",
    explanation:
      "Tickets criados no mês, em qualquer situação: abertos, pendentes ou já resolvidos.",
    valueLabel: null,
    isTime: false,
  },
  waitingClient: {
    kind: "monthly",
    title: "Aguardando resposta do cliente",
    explanation:
      "Tickets em que o atendente falou por último, inclusive os já resolvidos. Pelo mês da última atividade.",
    valueLabel: "Esperando o cliente há",
    isTime: false,
  },
  avgInteractionSec: {
    kind: "monthly",
    title: "Duração média da interação",
    explanation: "Média do tempo entre a abertura e o fechamento dos tickets resolvidos no mês.",
    valueLabel: "Duração",
    isTime: true,
  },

  // ── Últimos 30 dias ──
  totalDaily: {
    kind: "daily",
    title: "Tickets por dia",
    explanation: "Tickets criados no dia, em qualquer situação.",
    valueLabel: null,
    isTime: false,
  },
};
